import { v4 as uuidv4 } from 'uuid';

export function cloneObject(object: any): any {
    return JSON.parse(JSON.stringify(object));
}

export function b64toArrayBuffer(b64File: string): any {
    const byteString = atob(b64File.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return ia;
}

export function base64toJson(base64String: string): any {
    const jsonString = atob(base64String);
    const jsonObject = JSON.parse(jsonString);

    return jsonObject;
}

export function generateUUID(): string {
    const uuid = uuidv4();

    return uuid;
}
